import { render, staticRenderFns } from "./RetailerProduct.vue?vue&type=template&id=7b5d7667&"
import script from "./RetailerProduct.vue?vue&type=script&lang=js&"
export * from "./RetailerProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports